import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const DEFAULT_WIDTH = '400px';
const DEFAULT_HEIGHT = '300px';

const MATCH_URL = 'vimeo.com';
const EMBED_URL = 'https://player.vimeo.com/video/';

// Regular Vimeo URLs (with optional unlisted-video hash in the path).
// Capture groups: 1 = videoId, 3 = hash (optional)
const REGULAR_WITH_HASH = /\/(\d+)(\/(\w+))\/?($|\?|#)/;
// Embed URLs use ?h=<hash> instead of /<hash>/
// Capture groups: 1 = videoId, 3 = hash
const EMBEDDED_WITH_HASH = /\/(\d+)\/?\?(h=(\w+))/;
const VIDEO_ID_PATTERN = /\/(\d+)/;

export const matchVimeo: ProviderMatcher = (url, params) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}

	let embedUrl = EMBED_URL;
	const regularMatch = REGULAR_WITH_HASH.exec(url);
	const embeddedMatch = EMBEDDED_WITH_HASH.exec(url);
	const matched = regularMatch ?? embeddedMatch;
	if (matched && matched[1]) {
		embedUrl = `${EMBED_URL}${matched[1]}`;
		const hash = matched[3];
		if (hash) {
			embedUrl += `?h=${hash}`;
		}
	} else {
		const idMatch = VIDEO_ID_PATTERN.exec(url);
		if (idMatch && idMatch[1]) {
			embedUrl = `${EMBED_URL}${idMatch[1]}`;
		}
	}

	return {
		kind: 'fullscreen-iframe',
		provider: 'Vimeo',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
